<template>
  <div class="namepage">
    <div class="nametitle">
      <span>{{hosInfo.Name}}</span>
    </div>
    <div v-html="hosInfo.Synopsis">{{hosInfo.Synopsis}}</div>
  </div>
</template>
<script>
import { GetHostInfoByID } from "@/services/getData.js";
import weui from "weui.js";
export default {
  name: "hos-name",
  data() {
    return {
      hosInfo: {},
      guid: this.$route.query.guid
    };
  },
  created: function() {
    var loading = weui.loading("loading", {
      className: "custom-classname",
      content: "加载中"
    });
    GetHostInfoByID().then(response => {
      loading.hide();
      this.hosInfo = response.data;
      console.info(this.hosInfo);
    });
  }
};
</script>
<style>
.namepage {
  height: 100%;
  width: 100%;
  background: white;
  padding: 0 0.12rem;
  box-sizing: border-box;
}
.nametitle {
  height: 0.8rem;
  line-height: 0.8rem;
  text-align: center;
  font-size: 0.3rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  border-bottom: 0.01rem solid rgba(221, 221, 221, 1);
}
</style>



// WEBPACK FOOTER //
// src/components/section-office/hos-name.vue